module.exports = __webpack_public_path__ + "static/media/TVSchoolLogoBlue.afd05fdf.svg";